<div class="selector">
    <a class="logo" routerLink="/" attr.aria-label="{{ 'sidebar.home' | translate }}">
        @if (company?.brandLogoFileId) {
            <img [attr.src]="getBrandLogoUrl(company.brandLogoFileId) | secure" alt="" />
        } @else {
            <app-humi-logo />
        }
    </a>

    <div *ngIf="!hasMultipleCompanies" class="company-name" [ngClass]="getCompanyNameVisibility()">
        <h4>{{ company?.name }}</h4>
    </div>

    <div *ngIf="hasMultipleCompanies" class="company-name" [ngClass]="getCompanyNameVisibility()">
        <button
            [disableRipple]="true"
            class="only-small animate-chevron"
            mat-button
            (click)="onToggleMobileCompanyDrawer()"
        >
            {{ currentTokenRole.companyName }}
            <mat-icon iconPositionEnd svgIcon="chevronDown"></mat-icon>
        </button>
        <button
            [disableRipple]="true"
            class="hide-small animate-chevron"
            mat-button
            [matMenuTriggerFor]="companiesMenu"
        >
            {{ currentTokenRole.companyName }}
            <mat-icon iconPositionEnd svgIcon="chevronDown"></mat-icon>
        </button>

        <mat-menu xPosition="before" #companiesMenu>
            <button
                mat-menu-item
                *ngFor="let tokenRole of uniqueCompanyTokenRoles"
                (click)="changeRole(tokenRole.roleId)"
                [disabled]="currentTokenRole.companyId === tokenRole.companyId"
            >
                {{ tokenRole.companyName }}
            </button>
        </mat-menu>
    </div>
</div>
